import type { AxiosRequestConfig } from 'axios';

import http from '@/pages/datalab/services/common/datalabRequest';
import type {
  ICommitNumberPackageRequest,
  ICreateNumberPackageRequest,
  IGetNumberPackageDetailRequest,
  IGetNumberPackageListRequest,
  IGetNumberPackageStatusRequest,
  INumberPackageDto,
} from './types';

/**
 * 拉取号码包列表（号码包管理表格、建图选择器）。
 *
 * @see 原 `Number/NumberPackage/service.getUserPackageTable`
 */
export function getNumberPackageList(
  params: IGetNumberPackageListRequest,
): Promise<{ data_list?: INumberPackageDto[]; row_count?: number; }> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/getDataPackageList',
    method: 'post',
    data: params,
  };
  return http(options);
}

/**
 * 轮询号码包提取任务状态。
 *
 * @see 原 `getDataPackageStatus`
 */
export function getNumberPackageStatus(
  params: IGetNumberPackageStatusRequest,
): Promise<{ data_list?: INumberPackageDto[]; }> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/getDataPackageStatus',
    method: 'post',
    data: params,
  };
  return http(options);
}

/**
 * 上传号码包后提交确认。
 *
 * @see 原 `commitPackage`
 */
export function commitNumberPackage(params: ICommitNumberPackageRequest): Promise<unknown> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/commitPackage',
    method: 'post',
    data: params,
  };
  return http(options);
}

/**
 * 拉取单个号码包详情（多维建图 / 提取编辑回显）。
 *
 * @see 原 `Extraction/service.getUserPackageDetail`
 */
export function getNumberPackageDetail(
  params: IGetNumberPackageDetailRequest,
): Promise<INumberPackageDto> {
  return http({
    url: '/api/v1/datalab/getDataPackageDetail',
    method: 'post',
    data: params,
  });
}

/**
 * 创建号码包（提取页保存）。
 *
 * @see 原 `Extraction/service.createDataPackage`
 */
export function createNumberPackage(
  params: ICreateNumberPackageRequest,
): Promise<{ code: number; }> {
  return http({
    url: '/api/v1/datalab/createDataPackage',
    method: 'post',
    data: params,
    rawData: true,
  });
}
